import { useEffect, useState } from 'react'
import { Wallet, Scale, ShieldCheck, Clock, BadgeCheck, Sparkles, type LucideIcon } from 'lucide-react'
import { useAppConfig } from '../../hooks/useAppConfig'

type Perk = { icon: LucideIcon; text: string; klarna?: boolean; feeSpecific?: boolean; freeOnly?: boolean }

const PERKS: Perk[] = [
  { icon: Wallet, text: 'Buy now, pay later available on your booking fee', klarna: true, feeSpecific: true },
  { icon: Sparkles, text: 'Completely free right now - no booking fee', freeOnly: true },
  { icon: Scale, text: 'Impartial advice - never tied to one plumber' },
  { icon: BadgeCheck, text: 'Qualified plumbers, checked against public registers' },
  { icon: Clock, text: 'Typically on-site in under 60 minutes' },
  { icon: ShieldCheck, text: 'Full refund if we can\'t find a plumber', feeSpecific: true },
]

/** Klarna wordmark badge in Klarna's brand pink (#FFB3C7). */
function KlarnaBadge() {
  return (
    <span
      className="inline-flex items-center rounded bg-[#FFB3C7] px-1.5 py-0.5 text-[11px] font-bold leading-none text-black flex-shrink-0"
      aria-label="Klarna"
    >
      Klarna
    </span>
  )
}

const ROTATE_MS = 4000

export function PerksBanner() {
  const [index, setIndex] = useState(0)
  const { paywallEnabled } = useAppConfig()
  const perks = paywallEnabled ? PERKS.filter(p => !p.freeOnly) : PERKS.filter(p => !p.feeSpecific)

  useEffect(() => {
    setIndex(0)
    const id = window.setInterval(() => {
      setIndex(i => (i + 1) % perks.length)
    }, ROTATE_MS)
    return () => window.clearInterval(id)
  }, [perks.length])

  return (
    <div className="bg-gray-900 text-white text-xs sm:text-sm">
      <div
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative"
        style={{ height: '34px' }}
        aria-live="polite"
      >
        {perks.map((perk, i) => {
          const Icon = perk.icon
          return (
            <div
              key={perk.text}
              className={`absolute inset-0 flex items-center justify-center gap-2 transition-opacity duration-500 ${i === index ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
              aria-hidden={i !== index}
            >
              <Icon className="h-3.5 w-3.5 text-gold-400 flex-shrink-0" />
              <span className="font-medium tracking-tight truncate">{perk.text}</span>
              {perk.klarna && <KlarnaBadge />}
            </div>
          )
        })}
      </div>
    </div>
  )
}
